
export default class TrackString {
    static createDialogChoiceParams(dialogId, situation, choice, contentId){
        return {
            dialog_id: dialogId,
            dialog_situation: situation,
            dialog_choice: choice,
            dialog_choice_content_id: contentId
        };
    }

    static createDialogParams(dialogId){
        return {
            dialog_id: dialogId
        };
    }

    static createScenarioEndParams(duration) {
        return {
            duration
        };
    }
}

// NB: Google Analytics naming convention for Events and Parameters is Snake Case 
TrackString.USER_ENVIRONMENT = "environment";

TrackString.EVENT_SESSION_START = "game_session_start";
TrackString.EVENT_SESSION_END = "game_session_end";

// NGT
TrackString.PERSISTENT_STORY_ID = "story_id";

TrackString.EVENT_SCENARIO_START = "scenario_start";
TrackString.EVENT_SCENARIO_END = "scenario_end";

TrackString.EVENT_DIALOG_START = "dialog_start";
TrackString.EVENT_DIALOG_END = "dialog_end";
TrackString.EVENT_DIALOG_CHOICE = "dialog_choice";

TrackString.EVENT_KEY_MOMENT_CHOICE = "key_moment_choice";

TrackString.EVENT_DECISION_DIALOG_START = "decision_start";
TrackString.EVENT_DECISION_DIALOG_END = "decision_end";
TrackString.EVENT_DECISION_CHOICE = "decision_choice";